import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { formatNumberEnglish } from '../../utils'
import CurrencyDisplay from '../shared/CurrencyDisplay'

interface RemainingAmountProps {
  remainingAmount: number
}

const RemainingAmount: React.FC<RemainingAmountProps> = ({ remainingAmount }) => {
  const { t, i18n } = useTranslation()
  const { settings } = useSelector((state: RootState) => state.settings)
  
  // Ensure i18n language matches settings
  useEffect(() => {
    if (i18n.language !== settings.language) {
      i18n.changeLanguage(settings.language)
    }
  }, [settings.language, i18n])

  // Memoize translation to ensure it updates when language changes
  const remainingText = useMemo(() => t('payment.remaining'), [t, i18n.language])

  return (
    <div className="self-stretch bg-white rounded-xl flex flex-col justify-start items-start">
        <div className="self-stretch pl-5 pr-4 py-4 inline-flex justify-end items-center gap-6 overflow-hidden">
       
        <div className="flex-1  justify-start text-text-primary text-base font-medium font-['IBM_Plex_Sans_Arabic'] leading-6">
          {remainingText}
        </div>
        <div className="flex justify-start items-center gap-1">
          <div className="flex items-center gap-1">
            <span className="text-right justify-start text-text-primary text-base font-semibold font-['IBM_Plex_Sans_Arabic'] leading-6" dir="ltr">
              {formatNumberEnglish(remainingAmount, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
            <CurrencyDisplay className="w-4 h-4" />
          </div>
        </div>
       
      </div>
    </div>
  )
}

export default RemainingAmount

